import Logo from '../../assets/images/logo-min.png';
import '../../styles/login.css';
import { useForm } from "react-hook-form";
import { httpInvoke } from '../../utils/HttpClient';
import { config } from '../../config/config';
import { useDispatch } from 'react-redux';
import { SETLOADER } from '../../actions';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import React, { useState } from 'react';
import { Container, Box, TextField, Button, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


const schema = yup.object().shape({
  password: yup
    .string()
    .required('Password is required')
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      'Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character'
    ),
  confirmPassword: yup
    .string()
    .required('Confirm password is required')
    .oneOf([yup.ref('password'), null], 'Passwords must match'),
});



const ResetPasswordPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

    let userToken = searchParams.get('token');


  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
  });


  function onSubmit(data) {
    dispatch({
      type: SETLOADER,
      payload: true
    });

    const requestData = {
      token: userToken,
      password: data.password,
    };


    httpInvoke(config.apiURLs.resetPassword, requestData).then((result) => {
      if (result.status) {
        dispatch({
          type: SETLOADER,
          payload: false
        });
        navigate('/auth/login');
      }
    }).catch((error) => {
      dispatch({
        type: SETLOADER,
        payload: false
      });
    });
  }

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 3,
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          borderRadius: 2,
          backgroundColor: "#f9f9f9",
        }}
      >
        <Typography variant="h4" sx={{ mb: 2 }}>
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "100px" }}
          />
        </Typography>
        <Typography variant="h5" sx={{ marginBottom: 2 }}>
          Reset Password
        </Typography>

        <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
          <TextField
            label="New Password"
            variant="outlined"
            type="password"
            fullWidth
            required
            {...register('password')}
            error={!!errors.password}
            helperText={errors.password?.message}
            sx={{ marginBottom: 2 }}
          />
          <TextField
            label="Confirm Password"
            variant="outlined"
            type="password"
            fullWidth
            required
            {...register('confirmPassword')}
            error={!!errors.confirmPassword}
            helperText={errors.confirmPassword?.message}
            sx={{ marginBottom: 2 }}
          />

          <Button type="submit" variant="contained" fullWidth sx={{ marginBottom: 2 }}>
            Reset Password
          </Button>
        </form>

        <Link
          to='/auth/login'
          variant="body2"
          sx={{
            textAlign: 'center',
            display: 'block',
            color: 'text.secondary',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          }}
        >
          Back to Login
        </Link>
      </Box>
    </Container>
  );
};

export default ResetPasswordPage;
